var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(-1569 -376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw",
    transform: "translate(1574.159 380.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M8.433,3.541,11.191,6.3,4.209,13.282,1.452,10.523Zm4.852-.665-1.23-1.23a1.221,1.221,0,0,0-1.724,0L9.152,2.824,11.91,5.582l1.375-1.375A.94.94,0,0,0,13.285,2.876ZM.008,14.4a.314.314,0,0,0,.38.373l3.074-.745L.7,11.27Z",
    transform: "translate(-0.001 -1.289)",
    fill: "#343333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.dd8cccc0813b6663ad984fe0378777db.svg";
export { ForwardRef as ReactComponent };